// GFM-lite markdown -> HTML: pipe tables, headers, bullet/numbered lists, **bold**, `code`, line breaks.
// HTML-escaped, so the output is safe to drop straight into dangerouslySetInnerHTML. The table/bold/code
// core was ported unchanged from the original static UI; headers and lists were added so multi-section
// analysis answers ("## Overall", "- Pilo carries the highest demand...") render as real structure
// instead of one flat run of text with literal "##"/"-" characters in it.

export function escapeHtml(s) {
  return (s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

function inlineMd(s) {
  return escapeHtml(s)
    .replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>")
    .replace(/`([^`]+)`/g, "<code>$1</code>");
}

function rowCells(l) {
  return l.replace(/^\s*\|/, "").replace(/\|\s*$/, "").split("|").map((c) => c.trim());
}

function isSep(l) {
  const c = rowCells(l).filter((x) => x !== "");
  return c.length > 0 && c.every((x) => /^:?-+:?$/.test(x));
}

const HEADER_RE = /^(#{1,6})\s+(.+)$/;
const BULLET_RE = /^\s*[-*]\s+(.+)$/;
const NUMBERED_RE = /^\s*\d+[.)]\s+(.+)$/;

export function mdToHtml(src) {
  const lines = (src || "").split("\n");
  let html = "";
  let i = 0;
  while (i < lines.length) {
    const line = lines[i];
    const header = HEADER_RE.exec(line);
    const bullet = BULLET_RE.exec(line);
    const numbered = NUMBERED_RE.exec(line);

    if (line.includes("|") && i + 1 < lines.length && isSep(lines[i + 1])) {
      const head = rowCells(line);
      i += 2;
      let body = "";
      while (i < lines.length && lines[i].includes("|") && lines[i].trim() !== "" && !isSep(lines[i])) {
        body += "<tr>" + rowCells(lines[i]).map((c) => `<td>${inlineMd(c)}</td>`).join("") + "</tr>";
        i++;
      }
      html +=
        '<div class="tbl-wrap"><table><thead><tr>' +
        head.map((h) => `<th>${inlineMd(h)}</th>`).join("") +
        "</tr></thead><tbody>" +
        body +
        "</tbody></table></div>";
    } else if (header) {
      // Cap at 3 visual levels (####+ reads the same as ###) — a chat bubble has no room for six
      // distinct heading sizes, and model output rarely nests deeper than that anyway.
      const level = Math.min(header[1].length, 3);
      html += `<div class="md-h md-h${level}">${inlineMd(header[2])}</div>`;
      i++;
    } else if (bullet || numbered) {
      const ordered = !!numbered;
      const re = ordered ? NUMBERED_RE : BULLET_RE;
      let items = "";
      while (i < lines.length && re.test(lines[i])) {
        items += `<li>${inlineMd(re.exec(lines[i])[1])}</li>`;
        i++;
      }
      html += (ordered ? "<ol>" : "<ul>") + items + (ordered ? "</ol>" : "</ul>");
    } else {
      html += (line.trim() === "" ? "" : inlineMd(line)) + "<br>";
      i++;
    }
  }
  return html;
}
